export class PlayerModel{
    public name = '';
}